import { jsx as _jsx } from "react/jsx-runtime";
import SaveIcon from '@mui/icons-material/Save';
import { IconButton, InputAdornment, List, ListItem, TextField } from '@mui/material';
import React, { useState } from 'react';
import { ActionIcons } from '../../Iconography';
export const EditableList = ({ currentList, setCurrentList, label, placeholder, dense = true, disabled = false, requireSave = true, }) => {
    const [localList, setLocalList] = useState([...currentList]);
    const handleRemove = (i) => {
        const clone = structuredClone(localList);
        clone.splice(i, 1);
        setCurrentList(clone);
    };
    const handleSave = (list) => {
        setCurrentList(structuredClone(list ?? localList));
    };
    const handleEdit = (e, i) => {
        const clone = structuredClone(localList);
        clone[i] = e.target.value;
        setLocalList(clone);
        if (!requireSave)
            handleSave(structuredClone(clone));
    };
    return (_jsx(List, { dense: dense, disablePadding: true, children: localList.map((item, i) => {
            return (_jsx(ListItem, { disableGutters: dense, secondaryAction: _jsx(IconButton, { "aria-label": "remove", onClick: () => handleRemove(i), color: "error", disabled: disabled, children: _jsx(ActionIcons.Delete, {}) }), children: _jsx(TextField, { label: label, placeholder: placeholder, variant: "outlined", size: 'small', fullWidth: true, value: item, onChange: (e) => handleEdit(e, i), disabled: disabled, slotProps: {
                        input: {
                            sx: { paddingRight: 0 },
                            endAdornment: requireSave ? (_jsx(InputAdornment, { position: "end", children: _jsx(IconButton, { "aria-label": "save", disabled: item === currentList[i], onClick: () => handleSave(), children: _jsx(SaveIcon, {}) }) })) : undefined,
                        },
                    } }) }, item?.sk ?? i));
        }) }));
};
